import React from 'react';
import styles from './Dashboard.module.css';
import { useNavigate } from 'react-router-dom';

interface DashboardProps {}

const Dashboard: React.FC<DashboardProps> = () => {

    const navigate = useNavigate();

    const qnapage = ()  =>{
      navigate('/qna');
    }

    const homepage = () =>{
      navigate('/');
    }

    const dashdetail = () => {
      navigate('/dashdetail');
    }

    return (
        <>
    <div className={styles.dashboard}>
      <div className={styles.header}>
        <div className={styles.frame_98}>
          <div className={styles.frame_20}>
            <img className={styles.ellipse_10} src="/images/Dashboard/ellipse-100.png" />
            <div className={styles.ai_builder} onClick={homepage}>Appefy</div>
          </div>
          <div className={styles.menu_items}>
            <div className={styles.meni_item_active}>
              <div className={styles.dashboard2}>Dashboard</div>
            </div>
            <div className={styles.menu_item}>
              <div className={styles.text}>Learn</div>
            </div>
            <div className={styles.menu_item}>
              <div className={styles.text}>Examples</div>
            </div>
          </div>
        </div>
        <div className={styles.frame_2608569}>
          <div className={styles.frame_2608568}>
            <div className={styles.frame_2608568}>
              <svg
                className={styles.language}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_856_14508"
                  style={{ maskType: 'alpha'}}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                >
                  <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_856_14508)">
                  <path
                    d="M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6792 2.2625 15.8875 2.7875C17.0958 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90417 21.2125 8.1125C21.7375 9.32083 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.8375 18.4292 8.6125 17.8375C8.3875 17.2458 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.1875 17.5583 6.9125 18.175C7.6375 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3625 18.7917 17.0875 18.175C17.8125 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6125 17.2458 15.3875 17.8375C15.1625 18.4292 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.5625 13.3375 7.5375 13.0125C7.5125 12.6875 7.5 12.35 7.5 12C7.5 11.65 7.5125 11.3125 7.5375 10.9875C7.5625 10.6625 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.10417 10.6625 4.0625 10.9875C4.02083 11.3125 4 11.65 4 12C4 12.35 4.02083 12.6875 4.0625 13.0125C4.10417 13.3375 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4375 13.3375 14.4625 13.0125C14.4875 12.6875 14.5 12.35 14.5 12C14.5 11.65 14.4875 11.3125 14.4625 10.9875C14.4375 10.6625 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.5625 10.6625 9.5375 10.9875C9.5125 11.3125 9.5 11.65 9.5 12C9.5 12.35 9.5125 12.6875 9.5375 13.0125C9.5625 13.3375 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.8958 13.3375 19.9375 13.0125C19.9792 12.6875 20 12.35 20 12C20 11.65 19.9792 11.3125 19.9375 10.9875C19.8958 10.6625 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4375 10.6625 16.4625 10.9875C16.4875 11.3125 16.5 11.65 16.5 12C16.5 12.35 16.4875 12.6875 16.4625 13.0125C16.4375 13.3375 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8125 6.44167 17.0875 5.825C16.3625 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1625 5.57083 15.3875 6.1625C15.6125 6.75417 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.3875 6.75417 8.6125 6.1625C8.8375 5.57083 9.1 5 9.4 4.45C8.46667 4.75 7.6375 5.20833 6.9125 5.825C6.1875 6.44167 5.58333 7.16667 5.1 8Z"
                    fill="#1C1B1F"
                  />
                </g>
              </svg>

              <div className={styles.english}>English</div>
            </div>
          </div>
          <div className={styles.frame_96}>
            <img className={styles.ellipse_22} src="/images/Dashboard/ellipse-220.png" />
            <div className={styles.account}>Account</div>
            <svg
              className={styles.chevron_down}
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.6727 8.16205C12.3473 7.83661 11.8196 7.83661 11.4942 8.16205L9.58346 10.0728L7.67271 8.16205C7.34727 7.83661 6.81964 7.83661 6.4942 8.16205C6.16876 8.48748 6.16876 9.01512 6.4942 9.34056L8.9942 11.8406C9.31964 12.166 9.84727 12.166 10.1727 11.8406L12.6727 9.34056C12.9981 9.01512 12.9981 8.48748 12.6727 8.16205Z"
                fill="#262626"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className={styles.frame_281}>
        <div className={styles.nav_menu}>
          <div className={styles.menu}>
            <div className={styles.menu2}>
              <div className={styles.remix_icons_line_system_arrow_left_line}>
                <svg
                  className={styles.group}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.52333 9.16786H16.6667V10.8345H6.52333L10.9933 15.3045L9.815 16.4829L3.33333 10.0012L9.815 3.51953L10.9933 4.69786L6.52333 9.16786Z"
                    fill="#262626"
                  />
                </svg>
              </div>
              <div className={styles.all_sites}>All sites</div>
            </div>
            <div className={styles.frame_2608576}>
              <div className={styles.sidemenu_item}>
                <div className={styles.frame_100}>
                  <svg
                    className={styles.bank_card}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 12.5013C5 12.0411 5.3731 11.668 5.83333 11.668H9.16667C9.6269 11.668 10 12.0411 10 12.5013C10 12.9615 9.6269 13.3346 9.16667 13.3346H5.83333C5.3731 13.3346 5 12.9615 5 12.5013Z"
                      fill="#262626"
                    />
                    <path
                      d="M1.66667 7.5H18.3333V9.16667H1.66667V7.5Z"
                      fill="#262626"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.46558 3.33203H13.5344C14.2052 3.33202 14.7589 3.33201 15.2099 3.36886C15.6783 3.40713 16.1089 3.48927 16.5133 3.69534C17.1405 4.01492 17.6504 4.52486 17.97 5.15206C18.1761 5.55651 18.2582 5.9871 18.2965 6.45551C18.3334 6.9065 18.3333 7.46013 18.3333 8.13093V11.8665C18.3333 12.5373 18.3334 13.0909 18.2965 13.5419C18.2582 14.0103 18.1761 14.4409 17.97 14.8453C17.6504 15.4725 17.1405 15.9825 16.5133 16.3021C16.1089 16.5081 15.6783 16.5903 15.2099 16.6285C14.7589 16.6654 14.2052 16.6654 13.5344 16.6654H6.4656C5.79479 16.6654 5.24115 16.6654 4.79015 16.6285C4.32173 16.5903 3.89114 16.5081 3.4867 16.3021C2.85949 15.9825 2.34956 15.4725 2.02998 14.8453C1.8239 14.4409 1.74177 14.0103 1.70349 13.5419C1.66665 13.0909 1.66666 12.5373 1.66667 11.8664V8.13095C1.66666 7.46014 1.66665 6.90651 1.70349 6.45551C1.74177 5.9871 1.8239 5.55651 2.02998 5.15206C2.34956 4.52486 2.85949 4.01492 3.4867 3.69534C3.89114 3.48927 4.32173 3.40713 4.79015 3.36886C5.24114 3.33201 5.79478 3.33202 6.46558 3.33203ZM4.92586 5.02999C4.56052 5.05984 4.37368 5.11395 4.24335 5.18035C3.92975 5.34014 3.67478 5.59511 3.51499 5.90871C3.44858 6.03905 3.39448 6.22588 3.36463 6.59123C3.33398 6.96631 3.33333 7.45155 3.33333 8.16537V11.832C3.33333 12.5458 3.33398 13.0311 3.36463 13.4062C3.39448 13.7715 3.44858 13.9584 3.51499 14.0887C3.67478 14.4023 3.92975 14.6573 4.24335 14.817C4.37368 14.8835 4.56052 14.9376 4.92586 14.9674C5.30094 14.9981 5.78618 14.9987 6.5 14.9987H13.5C14.2138 14.9987 14.6991 14.9981 15.0741 14.9674C15.4395 14.9376 15.6263 14.8835 15.7567 14.817C16.0703 14.6573 16.3252 14.4023 16.485 14.0887C16.5514 13.9584 16.6055 13.7715 16.6354 13.4062C16.666 13.0311 16.6667 12.5458 16.6667 11.832V8.16537C16.6667 7.45155 16.666 6.9663 16.6354 6.59123C16.6055 6.22588 16.5514 6.03905 16.485 5.90871C16.3252 5.59511 16.0703 5.34014 15.7567 5.18035C15.6263 5.11395 15.4395 5.05984 15.0741 5.02999C14.6991 4.99935 14.2138 4.9987 13.5 4.9987H6.5C5.78618 4.9987 5.30094 4.99935 4.92586 5.02999Z"
                      fill="#262626"
                    />
                  </svg>

                  <div className={styles.title}>Billings</div>
                </div>
              </div>
              <div className={styles.sidemenu_item2}>
                <div className={styles.frame_100}>
                  <svg
                    className={styles.settings}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.3333 10.0013C13.3333 11.8423 11.8409 13.3346 10 13.3346C8.15905 13.3346 6.66667 11.8423 6.66667 10.0013C6.66667 8.16035 8.15905 6.66797 10 6.66797C11.8409 6.66797 13.3333 8.16035 13.3333 10.0013ZM11.6667 10.0013C11.6667 10.9218 10.9205 11.668 10 11.668C9.07953 11.668 8.33333 10.9218 8.33333 10.0013C8.33333 9.08083 9.07953 8.33464 10 8.33464C10.9205 8.33464 11.6667 9.08083 11.6667 10.0013Z"
                      fill="#262626"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.8882 2.2766C11.5114 1.90051 10.9912 1.66797 10.4167 1.66797H9.58333C9.00883 1.66797 8.48865 1.90051 8.11176 2.2766C8.09716 2.29117 8.08277 2.30596 8.06861 2.32095C7.73547 2.67362 7.52415 3.14257 7.50194 3.66052L7.50127 3.67801C7.50042 3.70234 7.5 3.72677 7.5 3.7513V3.76319C7.5 3.79706 7.47941 3.82751 7.44812 3.84049C7.41681 3.85347 7.38072 3.84649 7.35675 3.82252L7.34835 3.81412C7.331 3.79677 7.31343 3.7798 7.29563 3.76319L7.28279 3.7513C6.90083 3.40075 6.41979 3.21858 5.93485 3.20477C5.91424 3.20419 5.89362 3.20391 5.873 3.20393C5.34056 3.20449 4.80831 3.40788 4.40207 3.81412L3.81282 4.40337C3.40658 4.80961 3.20319 5.34186 3.20262 5.8743C3.2026 5.89492 3.20289 5.91554 3.20347 5.93615C3.21727 6.42109 3.39945 6.90213 3.75 7.28409L3.76189 7.29693C3.77849 7.31473 3.79547 7.33231 3.81282 7.34965L3.82122 7.35806C3.84519 7.38203 3.85217 7.41811 3.83919 7.44942C3.82621 7.48071 3.79576 7.5013 3.76189 7.5013H3.75C3.72547 7.5013 3.70104 7.50173 3.67671 7.50257L3.65922 7.50324C3.14127 7.52545 2.67231 7.73677 2.31965 8.06991C2.30465 8.08408 2.28987 8.09846 2.2753 8.11306C1.89921 8.48995 1.66667 9.01014 1.66667 9.58464V10.418C1.66667 10.9925 1.89921 11.5127 2.2753 11.8895C2.28987 11.9041 2.30465 11.9185 2.31965 11.9327C2.67231 12.2658 3.14127 12.4772 3.65922 12.4994L3.67671 12.5C3.70104 12.5009 3.72547 12.5013 3.75 12.5013H3.76189C3.79576 12.5013 3.82621 12.5219 3.83919 12.5532C3.85217 12.5845 3.84519 12.6206 3.82122 12.6445L3.81282 12.653C3.79547 12.6703 3.77849 12.6879 3.76189 12.7057L3.75 12.7185C3.39945 13.1005 3.21727 13.5815 3.20347 14.0665C3.20289 14.0871 3.2026 14.1077 3.20262 14.1283C3.20319 14.6607 3.40658 15.193 3.81282 15.5992L4.40207 16.1885C4.80831 16.5947 5.34056 16.7981 5.873 16.7987C5.89362 16.7987 5.91424 16.7984 5.93485 16.7978C6.41979 16.784 6.90083 16.6019 7.28279 16.2513L7.29563 16.2394C7.31343 16.2228 7.331 16.2058 7.34835 16.1885L7.35675 16.1801C7.38072 16.1561 7.41681 16.1491 7.44812 16.1621C7.47941 16.1751 7.5 16.2055 7.5 16.2394V16.2513C7.5 16.2758 7.50042 16.3003 7.50127 16.3246L7.50194 16.3421C7.52415 16.86 7.73547 17.329 8.06861 17.6817C8.08277 17.6966 8.09716 17.7114 8.11176 17.726C8.48865 18.1021 9.00883 18.3346 9.58333 18.3346H10.4167C10.9912 18.3346 11.5114 18.1021 11.8882 17.726C11.9028 17.7114 11.9172 17.6966 11.9314 17.6817C12.2645 17.329 12.4759 16.86 12.4981 16.3421L12.4987 16.3246C12.4996 16.3003 12.5 16.2758 12.5 16.2513V16.2394C12.5 16.2055 12.5206 16.1751 12.5519 16.1621C12.5832 16.1491 12.6193 16.1561 12.6432 16.1801L12.6517 16.1885C12.669 16.2058 12.6866 16.2228 12.7044 16.2394L12.7172 16.2513C13.0992 16.6019 13.5802 16.784 14.0651 16.7978C14.0858 16.7984 14.1064 16.7987 14.127 16.7987C14.6594 16.7981 15.1917 16.5947 15.5979 16.1885L16.1872 15.5992C16.5934 15.193 16.7968 14.6607 16.7974 14.1283C16.7974 14.1077 16.7971 14.0871 16.7965 14.0665C16.7827 13.5815 16.6006 13.1005 16.25 12.7185L16.2381 12.7057C16.2215 12.6879 16.2045 12.6703 16.1872 12.653L16.1788 12.6445C16.1548 12.6206 16.1478 12.5845 16.1608 12.5532C16.1738 12.5219 16.2042 12.5013 16.2381 12.5013H16.25C16.2745 12.5013 16.299 12.5009 16.3233 12.5L16.3408 12.4994C16.8587 12.4772 17.3277 12.2658 17.6803 11.9327C17.6953 11.9185 17.7101 11.9041 17.7247 11.8895C18.1008 11.5127 18.3333 10.9925 18.3333 10.418V9.58464C18.3333 9.01014 18.1008 8.48995 17.7247 8.11306C17.7101 8.09846 17.6953 8.08408 17.6803 8.06991C17.3277 7.73677 16.8587 7.52545 16.3408 7.50324L16.3233 7.50257C16.299 7.50173 16.2745 7.5013 16.25 7.5013H16.2381C16.2042 7.5013 16.1738 7.48071 16.1608 7.44942C16.1478 7.41811 16.1548 7.38203 16.1788 7.35806L16.1872 7.34965C16.2045 7.33231 16.2215 7.31473 16.2381 7.29693L16.25 7.28409C16.6006 6.90213 16.7827 6.42109 16.7965 5.93615C16.7971 5.91554 16.7974 5.89492 16.7974 5.8743C16.7968 5.34186 16.5934 4.80961 16.1872 4.40337L15.5979 3.81412C15.1917 3.40788 14.6594 3.20449 14.127 3.20393C14.1064 3.20391 14.0858 3.20419 14.0651 3.20477C13.5802 3.21858 13.0992 3.40075 12.7172 3.7513L12.7044 3.76319C12.6866 3.7798 12.669 3.79677 12.6517 3.81412L12.6432 3.82252C12.6193 3.84649 12.5832 3.85347 12.5519 3.84049C12.5206 3.82751 12.5 3.79706 12.5 3.76319V3.7513C12.5 3.72677 12.4996 3.70234 12.4987 3.67801L12.4981 3.66052C12.4759 3.14257 12.2645 2.67362 11.9314 2.32095C11.9172 2.30596 11.9028 2.29117 11.8882 2.2766ZM9.58333 16.668C9.35322 16.668 9.16667 16.4814 9.16667 16.2513V16.2394C9.16667 15.5231 8.73234 14.8904 8.08653 14.6226C7.43938 14.3542 6.68443 14.4954 6.17824 15.0016L6.16984 15.01C6.00712 15.1727 5.7433 15.1727 5.58058 15.01L4.99133 14.4207C4.82861 14.258 4.82861 13.9942 4.99133 13.8315L4.99973 13.8231C5.50593 13.3169 5.64709 12.5619 5.37873 11.9148C5.11092 11.269 4.47818 10.8346 3.76189 10.8346H3.75C3.51988 10.8346 3.33333 10.6481 3.33333 10.418V9.58464C3.33333 9.35452 3.51988 9.16797 3.75 9.16797H3.76189C4.47818 9.16797 5.11093 8.73365 5.37873 8.08785C5.64709 7.44069 5.50593 6.68574 4.99973 6.17954L4.99133 6.17114C4.82861 6.00842 4.82861 5.7446 4.99133 5.58189L5.58058 4.99263C5.7433 4.82991 6.00712 4.82991 6.16984 4.99263L6.17824 5.00103C6.68443 5.50722 7.43938 5.6484 8.08653 5.38004C8.73236 5.11223 9.16667 4.47948 9.16667 3.76319V3.7513C9.16667 3.52118 9.35321 3.33464 9.58333 3.33464H10.4167C10.6468 3.33464 10.8333 3.52118 10.8333 3.7513V3.76319C10.8333 4.47948 11.2676 5.11223 11.9135 5.38004C12.5606 5.6484 13.3156 5.50722 13.8218 5.00103L13.8302 4.99263C13.9929 4.82991 14.2567 4.82991 14.4194 4.99263L15.0087 5.58189C15.1714 5.7446 15.1714 6.00842 15.0087 6.17114L15.0003 6.17954C14.4941 6.68574 14.3529 7.44069 14.6213 8.08785C14.8891 8.73365 15.5218 9.16797 16.2381 9.16797H16.25C16.4801 9.16797 16.6667 9.35452 16.6667 9.58464V10.418C16.6667 10.6481 16.4801 10.8346 16.25 10.8346H16.2381C15.5218 10.8346 14.8891 11.269 14.6213 11.9148C14.3529 12.5619 14.4941 13.3169 15.0003 13.8231L15.0087 13.8315C15.1714 13.9942 15.1714 14.258 15.0087 14.4207L14.4194 15.01C14.2567 15.1727 13.9929 15.1727 13.8302 15.01L13.8218 15.0016C13.3156 14.4954 12.5606 14.3542 11.9135 14.6226C11.2677 14.8904 10.8333 15.5231 10.8333 16.2394V16.2513C10.8333 16.4814 10.6468 16.668 10.4167 16.668H9.58333Z"
                      fill="#262626"
                    />
                  </svg>

                  <div className={styles.title}>Settings</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.controls}>
            <div className={styles.frame_303}>
              <div className={styles.frame_300}>
                <div className={styles.all}>All</div>
              </div>
              <div className={styles.frame_301}>
                <div className={styles.published}>Published</div>
              </div>
              <div className={styles.frame_302}>
                <div className={styles.in_process}>In process</div>
              </div>
            </div>
            <div className={styles.frame_278}>
              <div className={styles.search}>
                <div className={styles.content2}>
                  <div className={styles.remix_icons_line_system_search_line}>
                    <svg
                      className={styles.group2}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.0259 13.8488L18.595 17.4171L17.4159 18.5963L13.8475 15.0271C12.5198 16.0915 10.8684 16.6704 9.16669 16.668C5.02669 16.668 1.66669 13.308 1.66669 9.16797C1.66669 5.02797 5.02669 1.66797 9.16669 1.66797C13.3067 1.66797 16.6667 5.02797 16.6667 9.16797C16.6691 10.8696 16.0902 12.5211 15.0259 13.8488ZM13.3542 13.2305C14.4118 12.1429 15.0024 10.685 15 9.16797C15 5.94464 12.3892 3.33464 9.16669 3.33464C5.94335 3.33464 3.33335 5.94464 3.33335 9.16797C3.33335 12.3905 5.94335 15.0013 9.16669 15.0013C10.6837 15.0037 12.1416 14.4131 13.2292 13.3555L13.3542 13.2305Z"
                        fill="#737373"
                      />
                    </svg>
                  </div>
                  <div className={styles.text2}>Search</div>
                </div>
              </div>
              <div className={styles.dropdown}>
                <div className={styles.select}>
                  <div className={styles.remix_icons_fill_system_menu_fill}>
                    <svg
                      className={styles.group3}
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 4H21V6H3V4ZM3 11H18V13H3V11ZM3 18H15V20H3V18Z"
                        fill="#262626"
                      />
                    </svg>
                  </div>
                  <svg
                    className={styles.icon_chevron_down}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 6L8 10L12 6"
                      stroke="#737373"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <div className={styles.dropdown}>
                <div className={styles.select2}>
                  <div className={styles.remix_icons_line_system_filter_2_line}>
                    <svg
                      className={styles.group4}
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14 14V20L10 22V14L4 5V3H20V5L14 14ZM6.404 5L12 13.394L17.596 5H6.404Z"
                        fill="#262626"
                      />
                    </svg>
                  </div>
                  <svg
                    className={styles.icon_chevron_down2}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 10L8 6L4 10"
                      stroke="#737373"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className={styles.select_options}>
                  <div className={styles.frame_3}>
                    <div className={styles.top_section}>
                      <div className={styles.menu_item2}>
                        <div className={styles.checkbox}>
                          <div className={styles.checkbox2}></div>
                        </div>
                        <div className={styles.free_plan}>Free plan</div>
                      </div>
                      <div className={styles.menu_item2}>
                        <div className={styles.checkbox}>
                          <div className={styles.checkbox2}></div>
                        </div>
                        <div className={styles.pro_plan}>PRO plan</div>
                      </div>
                      <div className={styles.menu_item2}>
                        <svg
                          className={styles.checkbox3}
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="3"
                            y="3"
                            width="18"
                            height="18"
                            rx="2"
                            fill="#9176ED"
                          />
                          <path
                            d="M10 16.4L6 12.4L7.4 11L10 13.6L16.6 7L18 8.4L10 16.4Z"
                            fill="white"
                          />
                        </svg>

                        <div className={styles.ultimate_plan}>Ultimate plan</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.button_frame}>
                <div className={styles.button_text} onClick={qnapage}>Generate a new site</div>
              </div>

            </div>
          </div>
          <div className={styles.frame_283}>
            <div className={styles.all_projects}>All projects</div>
            <div className={styles.content3}>
              <div className={styles.new_card}>
                <div className={styles.frame_309} onClick={dashdetail}>
                  <div className={styles.frame_307}>
                    <img className={styles.exapmle} src="/images/Dashboard/exapmle0.png" />
                    <div className={styles.frame_306}>
                      <div className={styles.frame_315}>
                        <div className={styles.frame_314}>
                          <div className={styles.basic_plan}>Ultimate plan</div>
                        </div>
                        <div className={styles.button2}>
                          <svg
                            className={styles.line_01_up}
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M3.33333 2.5C3.79357 2.5 4.16667 2.8731 4.16667 3.33333V14.1667C4.16667 15.0871 4.91286 15.8333 5.83333 15.8333H16.6667C17.1269 15.8333 17.5 16.2064 17.5 16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H5.83333C3.99238 17.5 2.5 16.0076 2.5 14.1667V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M15.5893 2.74408C15.2638 2.41864 14.7362 2.41864 14.4108 2.74408L12.7441 4.41074C12.4187 4.73618 12.4187 5.26382 12.7441 5.58926C13.0695 5.91469 13.5972 5.91469 13.9226 5.58926L14.1667 5.34518V7.5C14.1667 10.2614 11.9281 12.5 9.16668 12.5H6.66668C6.20644 12.5 5.83334 12.8731 5.83334 13.3333C5.83334 13.7936 6.20644 14.1667 6.66668 14.1667H9.16668C12.8486 14.1667 15.8333 11.1819 15.8333 7.5V5.34518L16.0774 5.58926C16.4029 5.91469 16.9305 5.91469 17.2559 5.58926C17.5814 5.26382 17.5814 4.73618 17.2559 4.41074L15.5893 2.74408Z"
                              fill="white"
                            />
                          </svg>

                          <div className={styles.accept_all_cockies2}>Upgrade</div>
                        </div>
                      </div>
                      <svg
                        className={styles.more}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
                          fill="#262626"
                        />
                        <path
                          d="M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z"
                          fill="#262626"
                        />
                        <path
                          d="M17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12Z"
                          fill="#262626"
                        />
                      </svg>
                    </div>
                    <div className={styles.frame_312}>
                      <svg
                        className={styles.eye}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.33332 8.0013C5.33332 6.52854 6.52723 5.33464 7.99999 5.33464C9.47275 5.33464 10.6667 6.52854 10.6667 8.0013C10.6667 9.47406 9.47275 10.668 7.99999 10.668C6.52723 10.668 5.33332 9.47406 5.33332 8.0013ZM7.99999 6.66797C7.98107 6.66797 7.96223 6.66836 7.9435 6.66914C7.98009 6.77307 7.99999 6.88486 7.99999 7.0013C7.99999 7.55359 7.55227 8.0013 6.99999 8.0013C6.88355 8.0013 6.77176 7.9814 6.66783 7.94481C6.66705 7.96355 6.66666 7.98238 6.66666 8.0013C6.66666 8.73768 7.26361 9.33463 7.99999 9.33463C8.73637 9.33463 9.33332 8.73768 9.33332 8.0013C9.33332 7.26492 8.73637 6.66797 7.99999 6.66797Z"
                          fill="#262626"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.00014 2.66797C3.92764 2.66797 2.09289 5.85968 1.51334 7.16122C1.2744 7.69781 1.2744 8.3048 1.51334 8.84139C2.09289 10.1429 3.92764 13.3346 8.00014 13.3346C12.0728 13.3346 13.9073 10.1428 14.4868 8.84126C14.7257 8.30474 14.7257 7.69786 14.4868 7.16134C13.9073 5.85985 12.0728 2.66797 8.00014 2.66797ZM2.73137 7.70359C3.26003 6.51636 4.76332 4.0013 8.00014 4.0013C11.237 4.0013 12.7402 6.51646 13.2687 7.70364C13.3539 7.89496 13.3539 8.10764 13.2687 8.29896C12.7402 9.48615 11.237 12.0013 8.00014 12.0013C4.76332 12.0013 3.26003 9.48625 2.73137 8.29902C2.64617 8.10767 2.64617 7.89494 2.73137 7.70359Z"
                          fill="#262626"
                        />
                      </svg>

                      <div className={styles._183_views}>183 views</div>
                    </div>
                  </div>
                </div>
                <div className={styles.content4}>
                  <div className={styles.website_for_karate_school}>
                    Website for karate school
                  </div>
                  <div className={styles.www_karateschool_com}>www.karateschool.com</div>
                </div>
              </div>
              <div className={styles.new_card}>
                <div className={styles.frame_309}  onClick={dashdetail}>
                  <div className={styles.frame_307}>
                    <img className={styles.exapmle2} src="/images/Dashboard/exapmle1.png" />
                    <div className={styles.frame_306}>
                      <div className={styles.frame_315}>
                        <div className={styles.frame_314}>
                          <div className={styles.basic_plan}>Ultimate plan</div>
                        </div>
                        <div className={styles.button2}>
                          <svg
                            className={styles.line_01_up2}
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M3.33333 2.5C3.79357 2.5 4.16667 2.8731 4.16667 3.33333V14.1667C4.16667 15.0871 4.91286 15.8333 5.83333 15.8333H16.6667C17.1269 15.8333 17.5 16.2064 17.5 16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H5.83333C3.99238 17.5 2.5 16.0076 2.5 14.1667V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M15.5892 2.74408C15.2638 2.41864 14.7362 2.41864 14.4107 2.74408L12.7441 4.41074C12.4186 4.73618 12.4186 5.26382 12.7441 5.58926C13.0695 5.91469 13.5971 5.91469 13.9226 5.58926L14.1666 5.34518V7.5C14.1666 10.2614 11.9281 12.5 9.16665 12.5H6.66665C6.20641 12.5 5.83331 12.8731 5.83331 13.3333C5.83331 13.7936 6.20641 14.1667 6.66665 14.1667H9.16665C12.8485 14.1667 15.8333 11.1819 15.8333 7.5V5.34518L16.0774 5.58926C16.4028 5.91469 16.9305 5.91469 17.2559 5.58926C17.5813 5.26382 17.5813 4.73618 17.2559 4.41074L15.5892 2.74408Z"
                              fill="white"
                            />
                          </svg>

                          <div className={styles.accept_all_cockies2}>Upgrade</div>
                        </div>
                      </div>
                      <svg
                        className={styles.more2}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
                          fill="#262626"
                        />
                        <path
                          d="M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z"
                          fill="#262626"
                        />
                        <path
                          d="M17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12Z"
                          fill="#262626"
                        />
                      </svg>
                    </div>
                    <div className={styles.frame_312}>
                      <svg
                        className={styles.eye2}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.33335 8.0013C5.33335 6.52854 6.52726 5.33464 8.00002 5.33464C9.47278 5.33464 10.6667 6.52854 10.6667 8.0013C10.6667 9.47406 9.47278 10.668 8.00002 10.668C6.52726 10.668 5.33335 9.47406 5.33335 8.0013ZM8.00002 6.66797C7.9811 6.66797 7.96226 6.66836 7.94353 6.66914C7.98012 6.77307 8.00002 6.88486 8.00002 7.0013C8.00002 7.55359 7.55231 8.0013 7.00002 8.0013C6.88358 8.0013 6.77179 7.9814 6.66786 7.94481C6.66708 7.96355 6.66669 7.98238 6.66669 8.0013C6.66669 8.73768 7.26364 9.33463 8.00002 9.33463C8.7364 9.33463 9.33335 8.73768 9.33335 8.0013C9.33335 7.26492 8.7364 6.66797 8.00002 6.66797Z"
                          fill="#262626"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.00017 2.66797C3.92767 2.66797 2.09292 5.85968 1.51337 7.16122C1.27443 7.69781 1.27443 8.3048 1.51337 8.84139C2.09292 10.1429 3.92767 13.3346 8.00017 13.3346C12.0728 13.3346 13.9074 10.1428 14.4868 8.84126C14.7257 8.30474 14.7257 7.69786 14.4868 7.16134C13.9074 5.85985 12.0728 2.66797 8.00017 2.66797ZM2.7314 7.70359C3.26006 6.51636 4.76335 4.0013 8.00017 4.0013C11.2371 4.0013 12.7402 6.51646 13.2687 7.70364C13.3539 7.89496 13.3539 8.10764 13.2687 8.29896C12.7402 9.48615 11.2371 12.0013 8.00017 12.0013C4.76335 12.0013 3.26006 9.48625 2.7314 8.29902C2.6462 8.10767 2.6462 7.89494 2.7314 7.70359Z"
                          fill="#262626"
                        />
                      </svg>

                      <div className={styles._183_views}>183 views</div>
                    </div>
                  </div>
                </div>
                <div className={styles.content4}>
                  <div className={styles.website_for_karate_school}>
                    Website for karate school
                  </div>
                  <div className={styles.www_karateschool_com}>www.karateschool.com</div>
                </div>
              </div>
              <div className={styles.new_card}>
                <div className={styles.frame_309}  onClick={dashdetail}>
                  <div className={styles.frame_307}>
                    <img className={styles.exapmle2} src="/images/Dashboard/exapmle2.png" />
                    <div className={styles.frame_306}>
                      <div className={styles.frame_315}>
                        <div className={styles.frame_314}>
                          <div className={styles.basic_plan}>Ultimate plan</div>
                        </div>
                        <div className={styles.button2}>
                          <svg
                            className={styles.line_01_up3}
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M3.33333 2.5C3.79357 2.5 4.16667 2.8731 4.16667 3.33333V14.1667C4.16667 15.0871 4.91286 15.8333 5.83333 15.8333H16.6667C17.1269 15.8333 17.5 16.2064 17.5 16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H5.83333C3.99238 17.5 2.5 16.0076 2.5 14.1667V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M15.5893 2.74408C15.2639 2.41864 14.7362 2.41864 14.4108 2.74408L12.7441 4.41074C12.4187 4.73618 12.4187 5.26382 12.7441 5.58926C13.0696 5.91469 13.5972 5.91469 13.9226 5.58926L14.1667 5.34518V7.5C14.1667 10.2614 11.9281 12.5 9.16671 12.5H6.66671C6.20647 12.5 5.83337 12.8731 5.83337 13.3333C5.83337 13.7936 6.20647 14.1667 6.66671 14.1667H9.16671C12.8486 14.1667 15.8334 11.1819 15.8334 7.5V5.34518L16.0775 5.58926C16.4029 5.91469 16.9305 5.91469 17.256 5.58926C17.5814 5.26382 17.5814 4.73618 17.256 4.41074L15.5893 2.74408Z"
                              fill="white"
                            />
                          </svg>

                          <div className={styles.accept_all_cockies2}>Upgrade</div>
                        </div>
                      </div>
                      <svg
                        className={styles.more3}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
                          fill="#262626"
                        />
                        <path
                          d="M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z"
                          fill="#262626"
                        />
                        <path
                          d="M17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12Z"
                          fill="#262626"
                        />
                      </svg>
                    </div>
                    <div className={styles.frame_312}>
                      <svg
                        className={styles.eye3}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.33329 8.0013C5.33329 6.52854 6.5272 5.33464 7.99996 5.33464C9.47272 5.33464 10.6666 6.52854 10.6666 8.0013C10.6666 9.47406 9.47272 10.668 7.99996 10.668C6.5272 10.668 5.33329 9.47406 5.33329 8.0013ZM7.99996 6.66797C7.98104 6.66797 7.9622 6.66836 7.94347 6.66914C7.98006 6.77307 7.99996 6.88486 7.99996 7.0013C7.99996 7.55359 7.55224 8.0013 6.99996 8.0013C6.88352 8.0013 6.77173 7.9814 6.6678 7.94481C6.66702 7.96355 6.66663 7.98238 6.66663 8.0013C6.66663 8.73768 7.26358 9.33463 7.99996 9.33463C8.73634 9.33463 9.33329 8.73768 9.33329 8.0013C9.33329 7.26492 8.73634 6.66797 7.99996 6.66797Z"
                          fill="#262626"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.00011 2.66797C3.92761 2.66797 2.09286 5.85968 1.51331 7.16122C1.27437 7.69781 1.27437 8.3048 1.51331 8.84139C2.09286 10.1429 3.92761 13.3346 8.00011 13.3346C12.0727 13.3346 13.9073 10.1428 14.4868 8.84126C14.7256 8.30474 14.7256 7.69786 14.4868 7.16134C13.9073 5.85985 12.0727 2.66797 8.00011 2.66797ZM2.73134 7.70359C3.26 6.51636 4.76329 4.0013 8.00011 4.0013C11.237 4.0013 12.7401 6.51646 13.2687 7.70364C13.3539 7.89496 13.3539 8.10764 13.2687 8.29896C12.7401 9.48615 11.237 12.0013 8.00011 12.0013C4.76329 12.0013 3.26 9.48625 2.73134 8.29902C2.64614 8.10767 2.64614 7.89494 2.73134 7.70359Z"
                          fill="#262626"
                        />
                      </svg>

                      <div className={styles._183_views}>183 views</div>
                    </div>
                  </div>
                </div>
                <div className={styles.content4}>
                  <div className={styles.website_for_karate_school}>
                    Website for karate school
                  </div>
                  <div className={styles.www_karateschool_com}>www.karateschool.com</div>
                </div>
              </div>
              <div className={styles.new_card}>
                <div className={styles.frame_309 }  onClick={dashdetail}>
                  <div className={styles.frame_307}>
                    <img className={styles.exapmle2} src="/images/Dashboard/exapmle3.png" />
                    <div className={styles.frame_306}>
                      <div className={styles.frame_315}>
                        <div className={styles.frame_314}>
                          <div className={styles.basic_plan}>Ultimate plan</div>
                        </div>
                        <div className={styles.button2}>
                          <svg
                            className={styles.line_01_up4}
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M3.33333 2.5C3.79357 2.5 4.16667 2.8731 4.16667 3.33333V14.1667C4.16667 15.0871 4.91286 15.8333 5.83333 15.8333H16.6667C17.1269 15.8333 17.5 16.2064 17.5 16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H5.83333C3.99238 17.5 2.5 16.0076 2.5 14.1667V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M15.5893 2.74408C15.2638 2.41864 14.7362 2.41864 14.4108 2.74408L12.7441 4.41074C12.4187 4.73618 12.4187 5.26382 12.7441 5.58926C13.0695 5.91469 13.5972 5.91469 13.9226 5.58926L14.1667 5.34518V7.5C14.1667 10.2614 11.9281 12.5 9.16668 12.5H6.66668C6.20644 12.5 5.83334 12.8731 5.83334 13.3333C5.83334 13.7936 6.20644 14.1667 6.66668 14.1667H9.16668C12.8486 14.1667 15.8333 11.1819 15.8333 7.5V5.34518L16.0774 5.58926C16.4029 5.91469 16.9305 5.91469 17.2559 5.58926C17.5814 5.26382 17.5814 4.73618 17.2559 4.41074L15.5893 2.74408Z"
                              fill="white"
                            />
                          </svg>

                          <div className={styles.accept_all_cockies2}>Upgrade</div>
                        </div>
                      </div>
                      <svg
                        className={styles.more4}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
                          fill="#262626"
                        />
                        <path
                          d="M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z"
                          fill="#262626"
                        />
                        <path
                          d="M17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12Z"
                          fill="#262626"
                        />
                      </svg>
                    </div>
                    <div className={styles.frame_312}>
                      <svg
                        className={styles.eye4}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.33332 8.0013C5.33332 6.52854 6.52723 5.33464 7.99999 5.33464C9.47275 5.33464 10.6667 6.52854 10.6667 8.0013C10.6667 9.47406 9.47275 10.668 7.99999 10.668C6.52723 10.668 5.33332 9.47406 5.33332 8.0013ZM7.99999 6.66797C7.98107 6.66797 7.96223 6.66836 7.9435 6.66914C7.98009 6.77307 7.99999 6.88486 7.99999 7.0013C7.99999 7.55359 7.55227 8.0013 6.99999 8.0013C6.88355 8.0013 6.77176 7.9814 6.66783 7.94481C6.66705 7.96355 6.66666 7.98238 6.66666 8.0013C6.66666 8.73768 7.26361 9.33463 7.99999 9.33463C8.73637 9.33463 9.33332 8.73768 9.33332 8.0013C9.33332 7.26492 8.73637 6.66797 7.99999 6.66797Z"
                          fill="#262626"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.00014 2.66797C3.92764 2.66797 2.09289 5.85968 1.51334 7.16122C1.2744 7.69781 1.2744 8.3048 1.51334 8.84139C2.09289 10.1429 3.92764 13.3346 8.00014 13.3346C12.0728 13.3346 13.9073 10.1428 14.4868 8.84126C14.7257 8.30474 14.7257 7.69786 14.4868 7.16134C13.9073 5.85985 12.0728 2.66797 8.00014 2.66797ZM2.73137 7.70359C3.26003 6.51636 4.76332 4.0013 8.00014 4.0013C11.237 4.0013 12.7402 6.51646 13.2687 7.70364C13.3539 7.89496 13.3539 8.10764 13.2687 8.29896C12.7402 9.48615 11.237 12.0013 8.00014 12.0013C4.76332 12.0013 3.26003 9.48625 2.73137 8.29902C2.64617 8.10767 2.64617 7.89494 2.73137 7.70359Z"
                          fill="#262626"
                        />
                      </svg>

                      <div className={styles._183_views}>183 views</div>
                    </div>
                  </div>
                </div>
                <div className={styles.content4}>
                  <div className={styles.website_for_karate_school}>
                    Website for karate school
                  </div>
                  <div className={styles.www_karateschool_com}>www.karateschool.com</div>
                </div>
              </div>
              <div className={styles.new_card}>
                <div className={styles.frame_309}  onClick={dashdetail}>
                  <div className={styles.frame_307}>
                    <img className={styles.exapmle2} src="/images/Dashboard/exapmle4.png" />
                    <div className={styles.frame_306}>
                      <div className={styles.frame_315}>
                        <div className={styles.frame_314}>
                          <div className={styles.basic_plan}>Ultimate plan</div>
                        </div>
                        <div className={styles.button2}>
                          <svg
                            className={styles.line_01_up5}
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M3.33333 2.5C3.79357 2.5 4.16667 2.8731 4.16667 3.33333V14.1667C4.16667 15.0871 4.91286 15.8333 5.83333 15.8333H16.6667C17.1269 15.8333 17.5 16.2064 17.5 16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H5.83333C3.99238 17.5 2.5 16.0076 2.5 14.1667V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M15.5892 2.74408C15.2638 2.41864 14.7362 2.41864 14.4107 2.74408L12.7441 4.41074C12.4186 4.73618 12.4186 5.26382 12.7441 5.58926C13.0695 5.91469 13.5971 5.91469 13.9226 5.58926L14.1666 5.34518V7.5C14.1666 10.2614 11.9281 12.5 9.16665 12.5H6.66665C6.20641 12.5 5.83331 12.8731 5.83331 13.3333C5.83331 13.7936 6.20641 14.1667 6.66665 14.1667H9.16665C12.8485 14.1667 15.8333 11.1819 15.8333 7.5V5.34518L16.0774 5.58926C16.4028 5.91469 16.9305 5.91469 17.2559 5.58926C17.5813 5.26382 17.5813 4.73618 17.2559 4.41074L15.5892 2.74408Z"
                              fill="white"
                            />
                          </svg>

                          <div className={styles.accept_all_cockies2}>Upgrade</div>
                        </div>
                      </div>
                      <svg
                        className={styles.more5}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
                          fill="#262626"
                        />
                        <path
                          d="M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z"
                          fill="#262626"
                        />
                        <path
                          d="M17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12Z"
                          fill="#262626"
                        />
                      </svg>
                    </div>
                    <div className={styles.frame_312}>
                      <svg
                        className={styles.eye5}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.33335 8.0013C5.33335 6.52854 6.52726 5.33464 8.00002 5.33464C9.47278 5.33464 10.6667 6.52854 10.6667 8.0013C10.6667 9.47406 9.47278 10.668 8.00002 10.668C6.52726 10.668 5.33335 9.47406 5.33335 8.0013ZM8.00002 6.66797C7.9811 6.66797 7.96226 6.66836 7.94353 6.66914C7.98012 6.77307 8.00002 6.88486 8.00002 7.0013C8.00002 7.55359 7.55231 8.0013 7.00002 8.0013C6.88358 8.0013 6.77179 7.9814 6.66786 7.94481C6.66708 7.96355 6.66669 7.98238 6.66669 8.0013C6.66669 8.73768 7.26364 9.33463 8.00002 9.33463C8.7364 9.33463 9.33335 8.73768 9.33335 8.0013C9.33335 7.26492 8.7364 6.66797 8.00002 6.66797Z"
                          fill="#262626"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.00017 2.66797C3.92767 2.66797 2.09292 5.85968 1.51337 7.16122C1.27443 7.69781 1.27443 8.3048 1.51337 8.84139C2.09292 10.1429 3.92767 13.3346 8.00017 13.3346C12.0728 13.3346 13.9074 10.1428 14.4868 8.84126C14.7257 8.30474 14.7257 7.69786 14.4868 7.16134C13.9074 5.85985 12.0728 2.66797 8.00017 2.66797ZM2.7314 7.70359C3.26006 6.51636 4.76335 4.0013 8.00017 4.0013C11.2371 4.0013 12.7402 6.51646 13.2687 7.70364C13.3539 7.89496 13.3539 8.10764 13.2687 8.29896C12.7402 9.48615 11.2371 12.0013 8.00017 12.0013C4.76335 12.0013 3.26006 9.48625 2.7314 8.29902C2.6462 8.10767 2.6462 7.89494 2.7314 7.70359Z"
                          fill="#262626"
                        />
                      </svg>

                      <div className={styles._183_views}>183 views</div>
                    </div>
                  </div>
                </div>
                <div className={styles.content4}>
                  <div className={styles.website_for_karate_school}>
                    Website for karate school
                  </div>
                  <div className={styles.www_karateschool_com}>www.karateschool.com</div>
                </div>
              </div>
              <div className={styles.new_card}>
                <div className={styles.frame_309}  onClick={dashdetail}>
                  <div className={styles.frame_307}>
                    <img className={styles.exapmle2} src="/images/Dashboard/exapmle5.png" />
                    <div className={styles.frame_306}>
                      <div className={styles.frame_315}>
                        <div className={styles.frame_314}>
                          <div className={styles.basic_plan}>Ultimate plan</div>
                        </div>
                        <div className={styles.button2}>
                          <svg
                            className={styles.line_01_up6}
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M3.33333 2.5C3.79357 2.5 4.16667 2.8731 4.16667 3.33333V14.1667C4.16667 15.0871 4.91286 15.8333 5.83333 15.8333H16.6667C17.1269 15.8333 17.5 16.2064 17.5 16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H5.83333C3.99238 17.5 2.5 16.0076 2.5 14.1667V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M15.5893 2.74408C15.2639 2.41864 14.7362 2.41864 14.4108 2.74408L12.7441 4.41074C12.4187 4.73618 12.4187 5.26382 12.7441 5.58926C13.0696 5.91469 13.5972 5.91469 13.9226 5.58926L14.1667 5.34518V7.5C14.1667 10.2614 11.9281 12.5 9.16671 12.5H6.66671C6.20647 12.5 5.83337 12.8731 5.83337 13.3333C5.83337 13.7936 6.20647 14.1667 6.66671 14.1667H9.16671C12.8486 14.1667 15.8334 11.1819 15.8334 7.5V5.34518L16.0775 5.58926C16.4029 5.91469 16.9305 5.91469 17.256 5.58926C17.5814 5.26382 17.5814 4.73618 17.256 4.41074L15.5893 2.74408Z"
                              fill="white"
                            />
                          </svg>

                          <div className={styles.accept_all_cockies2}>Upgrade</div>
                        </div>
                      </div>
                      <svg
                        className={styles.more6}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
                          fill="#262626"
                        />
                        <path
                          d="M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z"
                          fill="#262626"
                        />
                        <path
                          d="M17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12Z"
                          fill="#262626"
                        />
                      </svg>
                    </div>
                    <div className={styles.frame_312}>
                      <svg
                        className={styles.eye6}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.33329 8.0013C5.33329 6.52854 6.5272 5.33464 7.99996 5.33464C9.47272 5.33464 10.6666 6.52854 10.6666 8.0013C10.6666 9.47406 9.47272 10.668 7.99996 10.668C6.5272 10.668 5.33329 9.47406 5.33329 8.0013ZM7.99996 6.66797C7.98104 6.66797 7.9622 6.66836 7.94347 6.66914C7.98006 6.77307 7.99996 6.88486 7.99996 7.0013C7.99996 7.55359 7.55224 8.0013 6.99996 8.0013C6.88352 8.0013 6.77173 7.9814 6.6678 7.94481C6.66702 7.96355 6.66663 7.98238 6.66663 8.0013C6.66663 8.73768 7.26358 9.33463 7.99996 9.33463C8.73634 9.33463 9.33329 8.73768 9.33329 8.0013C9.33329 7.26492 8.73634 6.66797 7.99996 6.66797Z"
                          fill="#262626"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.00011 2.66797C3.92761 2.66797 2.09286 5.85968 1.51331 7.16122C1.27437 7.69781 1.27437 8.3048 1.51331 8.84139C2.09286 10.1429 3.92761 13.3346 8.00011 13.3346C12.0727 13.3346 13.9073 10.1428 14.4868 8.84126C14.7256 8.30474 14.7256 7.69786 14.4868 7.16134C13.9073 5.85985 12.0727 2.66797 8.00011 2.66797ZM2.73134 7.70359C3.26 6.51636 4.76329 4.0013 8.00011 4.0013C11.237 4.0013 12.7401 6.51646 13.2687 7.70364C13.3539 7.89496 13.3539 8.10764 13.2687 8.29896C12.7401 9.48615 11.237 12.0013 8.00011 12.0013C4.76329 12.0013 3.26 9.48625 2.73134 8.29902C2.64614 8.10767 2.64614 7.89494 2.73134 7.70359Z"
                          fill="#262626"
                        />
                      </svg>

                      <div className={styles._183_views}>183 views</div>
                    </div>
                  </div>
                </div>
                <div className={styles.content4}>
                  <div className={styles.website_for_karate_school}>
                    Website for karate school
                  </div>
                  <div className={styles.www_karateschool_com}>www.karateschool.com</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.help_resources}>
        <div className={styles.group_16}>
          <div className={styles.overlay}>
            <div className={styles.help_resources2}>Help &amp; Resources</div>
          </div>
          <svg
            className={styles.polygon_7}
            width="15.999999046325684"
            height="16.000001907348633"
          ></svg>
        </div>
        <div className={styles.button3}>
          <svg
            className={styles.question_mark_cr_fr}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.13914 8.22264C8.53753 8.45309 9.0473 8.31696 9.27775 7.91857C10.0753 6.76413 11.6168 8.3013 10.3529 9.05267C10.1257 9.18773 9.82862 9.41253 9.60264 9.68792C9.38867 9.94867 9.19215 10.3073 9.16904 10.748C9.1661 10.7765 9.16459 10.8054 9.16459 10.8346C9.16459 11.2949 9.53769 11.668 9.99792 11.668C10.6331 11.668 10.7541 11.3305 10.8761 10.99C10.9546 10.7709 11.0335 10.5506 11.2501 10.418C11.939 9.99629 12.5001 9.24941 12.5001 8.33464C12.5001 6.95392 11.3808 5.83464 10.0001 5.83464C9.07371 5.83464 8.26608 6.33895 7.83508 7.08403C7.60462 7.48241 7.74076 7.99219 8.13914 8.22264Z"
              fill="white"
            />
            <path
              d="M9.16459 13.3346C9.16459 12.8744 9.53769 12.5013 9.99792 12.5013C10.4582 12.5013 10.8313 12.8744 10.8313 13.3346C10.8313 13.7949 10.4582 14.168 9.99792 14.168C9.53769 14.168 9.16459 13.7949 9.16459 13.3346Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.99996 1.66797C5.39759 1.66797 1.66663 5.39893 1.66663 10.0013C1.66663 14.6037 5.39759 18.3346 9.99996 18.3346C14.6023 18.3346 18.3333 14.6037 18.3333 10.0013C18.3333 5.39893 14.6023 1.66797 9.99996 1.66797ZM3.33329 10.0013C3.33329 6.3194 6.31806 3.33464 9.99996 3.33464C13.6819 3.33464 16.6666 6.3194 16.6666 10.0013C16.6666 13.6832 13.6819 16.668 9.99996 16.668C6.31806 16.668 3.33329 13.6832 3.33329 10.0013Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>
  </>
    );
};

export default Dashboard;
